import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoRequestHttpComponent } from './listado-request-http/listado-request-http.component';
import { ListadoEventosLoraComponent } from './listado-eventos-lora/listado-eventos-lora.component';
import { ListadoLogsMensajesTestComponent } from './listado-logs-genericos/listado-logs-mensajes-test.component';
import { MetricasDownlinksComponent } from './metricas-downlinks/metricas-downlinks.component';

const routes: Routes = [
  { path: '', redirectTo: 'requesthttp', pathMatch: 'full' },

  //Request Http
  {
    path: 'requesthttp',
    title: 'Requests HTTP',
    component: ListadoRequestHttpComponent,
    canActivate: [],
  },

  //Eventos MQTT
  {
    path: 'eventosmqtt',
    title: 'Eventos LoRaWAN',
    component: ListadoEventosLoraComponent,
    canActivate: [],
  },
  {
    path: 'logsmensajestest',
    title: 'Logs de prueba',
    component: ListadoLogsMensajesTestComponent,
    canActivate: [],
  },
  {
    path: 'metricas-cola',
    title: 'Métricas de downlinks',
    component: MetricasDownlinksComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LogsRoutingModule {}
